export const ASOS_WORLD_URL_PATHS = {
  DE: "/entdecken/asos-world/"
};

export const DEFAULT_ASOS_WORLD_URL = "/discover/asos-world/";

export const getAsosWorldUrl = storeCode =>
  ASOS_WORLD_URL_PATHS[storeCode] || DEFAULT_ASOS_WORLD_URL;
